export const DEFAULT_LOCALE_SELECT_TEST_IDS = {
  bannerSettingDisabled: 'default-locale-dropdown-banner-setting-disabled',
  bannerSpecialDefault: 'default-locale-dropdown-banner-special-default',
  dropdown: 'default-locale-dropdown',
};
